import { TLineWiseEfficiency, TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellTree, TTableOptions, TTextCell } from '../../table.type';

const getProductHeaders = (
  allocatedProductTypes: TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY['allocatedProductTypes'],
) => {
  return allocatedProductTypes.map((p) => {
    return {
      type: 'TEXT_CELL' as TTextCell['type'],
      text: p.name,
      liftedInput: {
        input: {
          type: 'INPUT',
          subType: 'number',
          min: 0,
          setValue: (v: TLineWiseEfficiency) => {
            console.log('setValue', v, v.efficiency_by_product_type.find((prod) => prod.id === p.id)?.id);
            return v.efficiency_by_product_type.find((prod) => prod.id === p.id)?.efficiency;
          },
        },
        metadata: {
          keyName: p.id,
        },
      },
    };
  });
};

const getProductCellValues = (
  allocatedProductTypes: TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY['allocatedProductTypes'],
  item: TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY['lineWiseEfficiencies'][number],
): TTableCellTree[] => {
  return allocatedProductTypes.map((p) => {
    return {
      type: 'TEXT_CELL',
      text: item.efficiency_by_product_type.find((prod) => prod.id === p.id)?.efficiency || '--',
    };
  });
};

export const FACTORY_PRODUCT_LINE_EFFICIENCY_TABLE_MODEL = {
  createModel: (
    items: TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY['lineWiseEfficiencies'],
    allocatedProductTypes: TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY['allocatedProductTypes'],
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        select: {
          position: 'START',
          isMulti: true,
          size: 'DEFAULT',
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'ID',
            isHidden: true,
          },
          {
            type: 'TEXT_CELL',
            text: 'FLOOR',
          },
          {
            type: 'TEXT_CELL',
            text: 'SECTION',
          },
          {
            type: 'TEXT_CELL',
            text: 'LINES',
          },
          ...(getProductHeaders(allocatedProductTypes) as TTableOptions['headerConfig']),
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.id || '',
            },
            {
              type: 'TEXT_CELL',
              text: item.line_details['floor'],
            },
            {
              type: 'TEXT_CELL',
              text: item.line_details['section'],
            },
            {
              type: 'TEXT_CELL',
              text: item.line_details['line'],
            },
            ...getProductCellValues(allocatedProductTypes, item),
          ],
        };
      },
    );
  },

  createIdentityModel: () => {
    return ModifiersZTableModel.createTableModel(
      [] as TLineWiseEfficiency[],
      {
        padding: 8,
        headerConfig: [],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [],
        };
      },
    );
  },
};
